/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAwsSsmCommandExecutionJobs extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAwsSsmCommandExecutionJobs");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAwsSsmCommandExecutionJobs.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAwsSsmCommandExecutionJobs>): BackgroundJobPayloadForAwsSsmCommandExecutionJobs {
        let obj = Object.assign(new BackgroundJobPayloadForAwsSsmCommandExecutionJobs(), model);
        BackgroundJobPayloadForAwsSsmCommandExecutionJobs.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAwsSsmCommandExecutionJobs>): BackgroundJobPayloadForAwsSsmCommandExecutionJobs {
        if (!model) return null;
        return BackgroundJobPayloadForAwsSsmCommandExecutionJobs.newInstance(<BackgroundJobPayloadForAwsSsmCommandExecutionJobs> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAwsSsmCommandExecutionJobs) {
        if (!obj) return;

        models.BackgroundJobPayloadForAwsSsmCommandExecutionJobs.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAwsSsmCommandExecutionJobs): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAwsSsmCommandExecutionJobs.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Execution ID of the command document
     */
    command_execution_id: string;

}
